/* eslint-disable no-new,max-classes-per-file,no-use-before-define */
import $ from 'jquery';

export default class LimitedMultipleChoice {
    constructor() {
        this.$limitedMultipleChoice = $('.js-limited-multiple-choice');
        this.init();
    }

    init() {
        this.isInitialized = true;

        if (!this.$limitedMultipleChoice.length) {
            this.isInitialized = false;
            return;
        }

        this.$limitedMultipleChoice.each((i, el) => {
            new LimitedMultipleChoiceInstance($(el));
        });
    }
}

export class LimitedMultipleChoiceInstance {
    constructor($container) {
        this.$container = $container;
        this.checked = 0;
        this.overLimit = false;
        this.init();
    }

    init() {
        if (this.$container) {
            this.maxLimitedOptions = this.$container.data('max-limited-options');
            if (!this.maxLimitedOptions) return;

            this.$checkboxes = this.$container.find('*.mc-checkbox__input');
            this.$limitedValue = this.$container.find('*.limited-value');

            this.updateCheckedValue();

            this.$checkboxes.on('change', () => {
                this.updateCheckedValue();

                if (this.checked >= this.maxLimitedOptions) {
                    this.overLimit = true;

                    [...this.$checkboxes].forEach((elem) => {
                        if (!elem.checked) {
                            elem.classList.add('disabled');
                            elem.parentElement.classList.add('mc-checkbox--disabled');
                        }
                    });
                } else if (this.overLimit) {
                    this.overLimit = false;

                    [...this.$checkboxes].forEach((elem) => {
                        if (!elem.checked) {
                            elem.classList.remove('disabled');
                            elem.parentElement.classList.remove('mc-checkbox--disabled');
                        }
                    });
                }
            });
        }
    }

    updateCheckedValue() {
        this.checked = 0;

        [...this.$checkboxes].forEach((elem) => {
            if (elem.checked) {
                this.checked += 1;
            }
        });

        this.$limitedValue.text(`(${this.checked}/${this.maxLimitedOptions})`);
    }
}
